/**
 * Supported languages for static UI translations (admin-editable).
 * URL code used in routes; code used for API and i18n.
 */
export const languageConfig = {
  defaultLanguage: 'en',
  supportedLanguages: [
    { code: 'en', urlCode: 'en', name: 'English', nativeName: 'English', dir: 'ltr', default: true },
    { code: 'es', urlCode: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr', default: false },
    { code: 'fr', urlCode: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr', default: false },
    { code: 'de', urlCode: 'de', name: 'German', nativeName: 'Deutsch', dir: 'ltr', default: false },
  ],
  getLanguageCodes: () => languageConfig.supportedLanguages.map((l) => l.code),
  getUrlCodes: () => languageConfig.supportedLanguages.map((l) => l.urlCode),
  getLanguage: (code) =>
    languageConfig.supportedLanguages.find((l) => l.code === code) ||
    languageConfig.supportedLanguages.find((l) => l.default),
  getLanguageByUrlCode: (urlCode) =>
    languageConfig.supportedLanguages.find((l) => (l.urlCode || l.code) === urlCode),
  getUrlCode: (code) => {
    const lang = languageConfig.getLanguage(code);
    return lang ? (lang.urlCode || lang.code) : code;
  },
};

export default languageConfig;
